import moment from "../utils/app_moment";
import db from "../utils/firestore";
import { IReport, ReportDuration } from "intake_shared/src/types";
import { Collection } from "intake_shared/src/enum";

export async function getReportData(
    duration: ReportDuration
): Promise<IReport | undefined> {
    const report_key = `${moment().startOf(duration).toDate().getTime()}`;
    const report_doc = await db.collection(Collection.REPORT).doc(report_key).get();
    if (report_doc.exists) {
        return report_doc.data() as IReport;
    }
}
